import { axiosInstance, baseUrl } from "./auth";
import { useQuery } from 'react-query'
import { ApiStatus } from "../constants";



export const  INVENTORY_LIST = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/list`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  INVENTORY_ADD = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  INVENTORY_UPDATE = async (body) => {
    let response = await axiosInstance.put(`${baseUrl}/inventory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  INVENTORY_DELETE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/deleteInventory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}


export const  CATEGORY_LIST = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/listCategory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  VENDOR_LIST = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/listVendor`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  ADD_CATEGRORY = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/category`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  ADD_VENDOR = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/vendor`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}


export const  INVENTORY_STATUS_CHANGE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/toggleStatusInventory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}







